import { render, staticRenderFns } from "./students-manual-ghiab.vue?vue&type=template&id=1c04225b&"
import script from "./students-manual-ghiab.vue?vue&type=script&lang=js&"
export * from "./students-manual-ghiab.vue?vue&type=script&lang=js&"
import style0 from "./students-manual-ghiab.vue?vue&type=style&index=0&id=1c04225b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports